const headers = {
  name: "Candidates",
  navigate: {
    path: [
      {
        name: "Candidates",
        path: "/app/careers/candidates",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
